import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
// import { Eye, EyeOff, User, Mail, Lock, Phone } from "lucide-react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Person from '@mui/icons-material/Person';
import Email from '@mui/icons-material/Email';
import Lock from '@mui/icons-material/Lock';
import PhoneAndroid from '@mui/icons-material/PhoneAndroid';
import  CircleMatrix  from "examples/CircleMatrix" 
import { useState } from "react";
// import Imagefile from 'assets/images/login.png';

function SignupComponent({
  techyrrAdmin,
  handleSignup,
  handleGotoSignIn = null,
  credentials,
  onChange,
  creatingAccount,
}) {
  const { origin } = useParams();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="flex h-screen w-full">
      {/* Left - Form Card */}
      <div className="flex w-full items-center justify-center bg-white md:w-2/5">
      <div className="w-full max-w-md rounded-2xl bg-white p-10">
      <h1 className="mb-2 text-center text-4xl font-semibold text-gray-900">
            {origin === "techyrr"
              ? techyrrAdmin
                ? "Recruiter "
                : "Student "
              : ""}
            Create your account
          </h1>
          <p className="mb-6 text-center text-lg text-gray-500">
            Sign up to start your journey with us
          </p>

          <form className="space-y-5">
            <TextInput icon={<Person />} placeholder="Full Name" name="fullName" value={credentials.fullName} onChange={onChange} />
            <TextInput icon={<Email />} placeholder="Email" type="email" name="email" value={credentials.email} onChange={onChange} />
            <TextInput icon={<PhoneAndroid />} placeholder="Phone" name="phone" value={credentials.phone} onChange={onChange} />
            <SelectInput icon={<Person />} name="gender" value={credentials.gender} onChange={onChange} />
            <PasswordInput show={showPassword} setShow={setShowPassword} name="password" value={credentials.password} onChange={onChange} placeholder="Password" />

            <button
              type="button"
              disabled={creatingAccount}
              onClick={handleSignup}
              className="w-full rounded-xl bg-black py-3 text-lg font-semibold text-white transition-colors hover:bg-gray-900"
            >
              {creatingAccount ? "Signing Up..." : "Sign Up"}
            </button>
          </form>

          {/* Sign in Link */}
          {handleGotoSignIn && (
            <p className="mt-6 text-center text-sm text-gray-500">
              Already have an account?{" "}
              <span
                onClick={handleGotoSignIn}
                className="cursor-pointer font-medium text-black underline"
              >
                Sign In
              </span>
            </p>
          )}
        </div>
      </div>

      {/* Right - Background */}
      <div className="relative hidden md:block md:w-3/5">
          <CircleMatrix />
      </div>
    </div>
  );
}

// Reusable Components
function TextInput({ icon, ...props }) {
  return (
    <div className="relative">
      <input
        {...props}
        className="w-full rounded-xl bg-gray-100 px-12 py-3 text-lg outline-none placeholder-gray-500"
      />
      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
        {icon}
      </span>
    </div>
  );
}

function PasswordInput({ show, setShow, ...props }) {
  return (
    <div className="relative">
      <input
        {...props}
        type={show ? "text" : "password"}
        className="w-full rounded-xl bg-gray-100 px-12 py-3 text-lg outline-none placeholder-gray-500"
      />
      <Lock className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
      <button
        type="button"
        className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400"
        onClick={() => setShow(!show)}
      >
        {show ? <VisibilityOff className="h-5 w-5" /> : <Visibility className="h-5 w-5" />}
      </button>
    </div>
  );
}

function SelectInput({ icon, name, value, onChange }) {
  return (
    <div className="relative">
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="w-full appearance-none rounded-xl bg-gray-100 px-12 py-3 text-lg text-gray-700 outline-none"
      >
        <option value="">Select Gender</option>
        <option value="male">Male</option>
        <option value="female">Female</option>
        <option value="other">Other</option>
      </select>
      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">{icon}</span>
    </div>
  )
}

// Props Validation
SignupComponent.propTypes = {
  techyrrAdmin: PropTypes.bool,
  handleSignup: PropTypes.func.isRequired,
  handleGotoSignIn: PropTypes.func,
  credentials: PropTypes.shape({
    fullName: PropTypes.string,
    gender: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    company: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  creatingAccount: PropTypes.bool.isRequired,
};

export default SignupComponent;
